import * as React from 'react';
import { createSvgIcon } from '@mui/material';
var PopulateEmpty = createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  id: "populateEmpty",
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  version: "1.1"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.0041667,9.35 C16.6743426,9.35 18.8416667,11.5165078 18.8416667,14.1875 C18.8416667,16.8576759 16.6743426,19.025 14.0041667,19.025 C11.3339907,19.025 9.16666667,16.8576759 9.16666667,14.1875 C9.16666667,11.5165078 11.3339907,9.35 14.0041667,9.35 Z M3.33313359,14.9993009 L3.33313359,16.6666667 C2.41630713,16.6666667 1.66666667,15.9170262 1.66666667,14.9993009 L1.66666667,14.9993009 L3.33313359,14.9993009 Z M6.66606743,15.0001997 L6.66606743,16.6666667 L4.99960051,16.6666667 L4.99960051,15.0001997 L6.66606743,15.0001997 Z M14.4874269,11.76875 L13.5200901,11.76875 L13.5200901,13.7034235 L11.5854167,13.7034235 L11.5854167,14.6715765 L13.5200901,14.6715765 L13.5200901,16.60625 L14.4874269,16.60625 L14.4874269,14.6715765 L16.4229167,14.6715765 L16.4229167,13.7034235 L14.4874269,13.7034235 L14.4874269,11.76875 Z M3.33313359,11.6672659 L3.33313359,13.3337328 L1.66666667,13.3337328 L1.66666667,11.6672659 L3.33313359,11.6672659 Z M3.33313359,8.33343321 L3.33313359,9.99990013 L1.66666667,9.99990013 L1.66666667,8.33343321 L3.33313359,8.33343321 Z M3.33313359,5.00049936 L3.33313359,6.66696628 L1.66666667,6.66696628 L1.66666667,5.00049936 L3.33313359,5.00049936 Z M16.6666667,5.00049936 L16.6666667,6.66696628 L15.0001997,6.66696628 L15.0001997,5.00049936 L16.6666667,5.00049936 Z M3.33313359,1.66666667 L3.33313359,3.33313359 L1.66666667,3.33313359 C1.66666667,2.41630713 2.41630713,1.66666667 3.33313359,1.66666667 L3.33313359,1.66666667 Z M9.99990013,1.66666667 L9.99990013,3.33313359 L8.33343321,3.33313359 L8.33343321,1.66666667 L9.99990013,1.66666667 Z M15.0001997,1.66666667 C15.9170262,1.66666667 16.6666667,2.41630713 16.6666667,3.33313359 L16.6666667,3.33313359 L15.0001997,3.33313359 Z M6.66696628,1.66666667 L6.66696628,3.33313359 L5.00049936,3.33313359 L5.00049936,1.66666667 L6.66696628,1.66666667 Z M13.332834,1.66666667 L13.332834,3.33313359 L11.6663671,3.33313359 L11.6663671,1.66666667 L13.332834,1.66666667 Z",
  id: "populate-empty-path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "populate-empty-Map-Data",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "populate-empty-Map-Data-on-focus_no-mapping",
  transform: "translate(-1222.000000, -463.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "populate-empty-Group-13",
  transform: "translate(582.000000, 362.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "populate-empty-Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "populate-empty-ic_AddIfEmpty",
  transform: "translate(639.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "populate-empty-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  href: "#populate-empty-path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Fill-1",
  fill: "#000000",
  fillRule: "evenodd",
  href: "#populate-empty-path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Colors/Dark-Gray",
  mask: "url(#populate-empty-mask-2)",
  fill: "#616161",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-10.833333, -10.833333)",
  id: "populate-empty-Rectangle-Copy-29"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  width: "41.6666667",
  height: "41.6666667"
}))))))))), 'PopulateEmpty');
export { PopulateEmpty };